import { StaffLayout } from "@/components/layouts/staff-layout"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle, } from "@/components/ui/card"
import { MainContainer } from "@/components/ui/container"
import { router, Link, usePage } from "@inertiajs/react"
import { t } from "@/lib/i18n"

type Location = {
    id: number
    name: string
    status: string
    current: boolean
}
function locationStatusLabel(status: string) {
    if (status === "active")
        return t("ui.staff.locations.status.in_production")
    if (status === "suspended")
        return t("ui.staff.locations.status.suspended_billing")
    return t("ui.staff.locations.status.pending_configuration")
}
export default function StaffLocationsIndex() {
    const { locations } = usePage<{
        locations: Location[]
    }>().props

    const selectLocation = (locationId: number) => {
        router.post(`/locations/${locationId}/use_location`)
    }
    return (<StaffLayout>
      <MainContainer size="md">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="text-2xl font-semibold" data-testid="locations-title">{t("ui.react.pages.staff.locations.index.locations")}</h1>
            <p className="text-sm text-muted-foreground">{t("ui.react.pages.staff.locations.index.select_location_comenzar_work")}</p>
          </div>
          <Button asChild>
            <Link href="/locations/new">{t("ui.react.pages.staff.locations.index.new_location")}</Link>
          </Button>
        </div>

        {locations.length === 0 && (<Card data-testid="locations-empty-state">
            <CardHeader>
              <CardTitle>{t("ui.react.pages.staff.locations.index.no_tienes_locations")}</CardTitle>
              <CardDescription>{t("ui.react.pages.staff.locations.index.create_location_comenzar_manage")}</CardDescription>
            </CardHeader>
            <CardFooter>
              <Button asChild>
                <Link href="/locations/new">{t("ui.react.pages.staff.locations.index.create_location")}</Link>
              </Button>
            </CardFooter>
          </Card>)}

        {locations.length > 0 && (<div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {locations.map((location) => (<Card key={location.id} data-testid={`location-card-${location.id}`}>
                <CardHeader>
                  <CardTitle>{location.name}</CardTitle>
                  <CardDescription>
                    {location.current ? t("ui.staff.locations.current") : t("ui.staff.locations.available")}
                    {" · "}
                    {locationStatusLabel(location.status)}
                  </CardDescription>
                </CardHeader>
                <CardContent className="space-y-3">
                  <Button type="button" variant={location.current ? "secondary" : "default"} onClick={() => selectLocation(location.id)} data-testid={`use-location-${location.id}`}>
                    {location.current ? t("ui.staff.locations.using_current") : t("ui.staff.locations.use")}
                  </Button>
                </CardContent>
              </Card>))}
          </div>)}
      </MainContainer>
    </StaffLayout>)
}
